<template>
	<div>
		<firstsceenimage :imgobj='bigimage'></firstsceenimage>

		<div class="flexcenter" style="padding: 70px 0px 0px 0px; ">
			<div class="a3dtitle">
				<div style="margin-bottom:20px ; font-size: 36px;font-weight: bold;letter-spacing: 4px;">
					基于人体三维测量技术的3D扫描技术</div>
				<div style="color: #666666;font-size: 14px;">
					采用红外光学测量技术及多角度图像重建技术的人体三维扫描测量可在2秒内快速准确的获取人体三维数据及尺寸数据扫描速度快，抗干扰能力强，扫描无死角操作简单，交互性好，环境要求低
				</div>
			</div>
			<div>
				<img class="a3dimage1" src="../../static/3D数据扫描.gif" />
			</div>
		</div>



		<adword :backimg="adimg" viewheight="500" style="background-color:  #F8F8F8;">
			<div class="flexcenter" style="padding: 70px 0px 0px 0px; ">

				<div>
					<img class="a3dimage1" src="../../static/3D数据扫描2.gif" />
				</div>
				<div class="a3dtitle" style="text-align: left;margin-top: 150px;">
					<div style="margin-bottom:20px ; font-size: 36px;font-weight: bold;letter-spacing: 4px;">
						基于激光测量技术的3D扫描技术</div>
					<div style="color: #666666;font-size: 14px;">
						集光学图像、机械传动、电子控制、计算机工程、数据处理运算于一体的高效率高精度的激光3D测量采用红外激光重建技术及多组传感器多方位同步工作的方式可在几秒内快速准确的获取足部三维数据及尺寸数据
					</div>
				</div>
			</div>
		</adword>
		<div style="height: 50px;"></div>

		<adword title="人体3D数字化应用" slotheight="500">
			<div class="flexcenter" style="padding: 10px 40px 10px 40px;">
				<div @mouseenter="swimg(0)"
					style="position: relative;width: 347px;height:473px; overflow: hidden; margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 260px;width: 260px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 服装定制</div>
							<div
								style="margin-top: 20px;font-size: 12px;letter-spacing: 2px;line-height: 18px;opacity: 0.5;">
								三维扫描仪快速获取人体3D数据和尺寸数据，数据上传云端建立个人人体数据库。消费者选择喜欢的服装产品，系统为其匹配合适的产品。
							</div>
						</div>

					</div>
					<img :class="[swimgbool[0]?'imgscale':'']" style="height: 473px;z-index: 1;"
						src="../../static/服装定制.png">
				</div>


				<div @mouseenter="swimg(1)"
					style="position: relative;width: 347px;height:473px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 260px;width: 260px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 人体健康管理</div>
							<div
								style="margin-top: 20px;font-size: 12px;letter-spacing: 2px;line-height: 18px;opacity: 0.5;">
								通过对数据的科学分析和价值挖掘建立个人健康档案进行有针对性的治疗、康复训练、健身训练和矫治产品定制从而为患者提供更为完善的运动康复和健康管理方案。
							</div>
						</div>

					</div>
					<img :class="[swimgbool[1]?'imgscale':'']" style="height: 473px;z-index: 1;"
						src="../../static/人体健康管理.png">
				</div>



				<div @mouseenter="swimg(2)"
					style="position: relative;width: 347px;height:473px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 260px;width: 260px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 床垫枕头定制</div>
							<div
								style="margin-top: 20px;font-size: 12px;letter-spacing: 2px;line-height: 18px;opacity: 0.5;">
								获取人体3D数据以及曲面结构和压力数据，
								为客户定制出符合其体型特征和身体曲面结构的床垫及枕头，从而保护颈椎和脊椎，有效的改善身体健康状态。</div>
						</div>

					</div>
					<img :class="[swimgbool[2]?'imgscale':'']" style="height: 473px;z-index: 1;"
						src="../../static/床垫枕头定制.png">
				</div>




				<div @mouseenter="swimg(3)" style="position: relative;width: 347px;height:473px; overflow: hidden;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 260px;width: 260px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 人体体姿测评</div>
							<div
								style="margin-top: 20px;font-size: 12px;letter-spacing: 2px;line-height: 18px;opacity: 0.5;">
								实时获取人体骨架点， 创建人体多个骨架点的空间坐标通过对骨架点在坐标空间内的运动、偏移、坐标值的计算从而实现对人体各个部位姿态的测评分析。
							</div>
						</div>

					</div>
					<img :class="[swimgbool[3]?'imgscale':'']" style="height: 473px;z-index: 1;"
						src="../../static/人体体姿测评.png">
				</div>



			</div>
		</adword>
		<adword title="足部3D数字化应用" slotheight="600">
			<div class="flexcenter" style="padding: 10px 40px 10px 40px;">

				<div @mouseenter="swimg2(0)"
					style="position: relative;width: 347px;height:473px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 260px;width: 260px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 足部3D扫描</div>
							<div
								style="margin-top: 20px;font-size: 12px;letter-spacing: 2px;line-height: 18px;opacity: 0.5;">
								通过对足部数据进行分析评估，建立完整的人体数据库，挖掘数据深层价值，实现生产模式、业务模式、服务模式及全产业链的创新转型。足部3D数字化在鞋履定制、足部矫形、康复诊疗、足部研究等领域得到广泛应用。

							</div>
						</div>

					</div>
					<img :class="[swimgbool2[0]?'imgscale':'']" style="height: 473px;z-index: 1;"
						src="../../static/足部3D扫描.png">
				</div>


				<div style="width: 10px;height: 1px;"></div>

				<div @mouseenter="swimg2(1)"
					style="position: relative;width: 347px;height:473px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 260px;width: 260px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 个性化鞋履定制</div>
							<div
								style="margin-top: 20px;font-size: 12px;letter-spacing: 2px;line-height: 18px;opacity: 0.5;">
								消费者通过3D脚型扫描仪采集自身的脚型数据，上传云端建立个人脚型数据库。通过线下门店或线上购物平台选择喜欢的鞋履产品或定制服务，后台系统调用客户脚型数据并结合客户的需求，推荐合适的产品或鞋履定制服务。

							</div>
						</div>

					</div>
					<img :class="[swimgbool2[1]?'imgscale':'']" style="height: 473px;z-index: 1;"
						src="../../static/个性化鞋履定制.png">
				</div>


				<div style="width: 10px;height: 1px;"></div>

				<div @mouseenter="swimg2(2)"
					style="position: relative;width: 347px;height:473px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 260px;width: 260px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 儿童脚部成长发育预测</div>
							<div
								style="margin-top: 20px;font-size: 12px;letter-spacing: 2px;line-height: 18px;opacity: 0.5;">
								通过对儿童足部数据进行分析评估，结合医学理论与实践，对儿童脚部成长发育进行科学预测，从而脚部生长进行科学干预与矫正。并且可以定制符合具有矫正功能或其他特定功能的鞋子、鞋垫，帮助儿童保护脚部成长发育。

							</div>
						</div>

					</div>
					<img :class="[swimgbool2[2]?'imgscale':'']" style="height: 473px;z-index: 1;"
						src="../../static/儿童脚部成长发育预测.png">
				</div>


				<div style="width: 10px;height: 1px;"></div>

				<div @mouseenter="swimg2(3)"
					style="position: relative;width: 347px;height:473px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 260px;width: 260px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 足部诊疗康复</div>
							<div
								style="margin-top: 20px;font-size: 12px;letter-spacing: 2px;line-height: 18px;opacity: 0.5;">
								结合足部3D智能采集系统获取的足部3D数据、尺寸数据、足弓/足跟状态数据、足底受力区域等相关信息,
								科学制定矫正康复方案，定制符合具有矫正功能和保健功能的鞋子、鞋垫以及康复护具，并可实现长时间跟踪监测。

							</div>
						</div>

					</div>
					<img :class="[swimgbool2[3]?'imgscale':'']" style="height: 473px;z-index: 1;"
						src="../../static/足部诊疗康复.png">
				</div>



			</div>
			<div style="margin-top: 50px;color: #999999;font-weight: 400;font-size: 14px;">您可能对“C2M智能定制方案”感兴趣，去看看！</div>
		</adword>


	</div>
</template>
<script>
	import firstsceenimage from '../../components/firstsceenimage.vue'
	import adword from '../../components/adword.vue'
	import bigimage from '../../static/banner5.png'
	import advideo from '../../components/advideo.vue'
	import adimg from '../../static/波浪.png'
	export default {
		name: 'Pro3d',
		components: {
			firstsceenimage,
			adword,
			advideo,
		},
		data() {
			return {
				bigimage: bigimage,
				adimg: adimg,
				swimgbool: [false, false, false, false],
				swimgbool2: [false, false, false, false],
			}
		},
		methods: {
			swimg: function(index) {
				for (var i = 0; i < 6; i++) {
					if (index == i) {
						if (!this.swimgbool[index]) {
							this.$set(this.swimgbool, index, true)
						}
					} else {
						this.$set(this.swimgbool, i, false)
					}
				}

			},
			swimg2: function(index) {
				for (var i = 0; i < 6; i++) {
					if (index == i) {
						if (!this.swimgbool2[index]) {
							this.$set(this.swimgbool2, index, true)
						}
					} else {
						this.$set(this.swimgbool2, i, false)
					}
				}

			}
		}
	}
</script>

<style>
	@media (max-width: 888px) {
		.a3dtitle {
			width: 56%;
		}

		.a3dimage1 {
			width: 90%;
		}

	}

	@media (min-width: 1000px) {
		.a3dtitle {
			width: 670px;
		}

		.a3dimage1 {
			width: 700px;
		}
	}
</style>
